import { provideChameleonDesignSystem } from '@getgo/chameleon-toolkit';
import { chameleonBanner } from './Banner.definition';
import { chameleonButton } from '../Button/Button.definition';
import { chameleonIconButton } from '../IconButton/IconButton.definition';
import '@getgo/chameleon-typography/register/default';
provideChameleonDesignSystem().register(chameleonBanner(), chameleonButton(), chameleonIconButton());
